import API from "../../../../../global/api";
import { socket } from "../../../../../socket.js";

// ─────────────────────────────────────────────────────────────────────────────
// GET STATUS
// ─────────────────────────────────────────────────────────────────────────────
export const requestGetWhatsAppStatus = () => ({
    type: "REQUEST_GET_WHATSAPP_STATUS",
});
export const successGetWhatsAppStatus = (data) => ({
    type: "SUCCESS_GET_WHATSAPP_STATUS",
    payload: data,
});
export const errorGetWhatsAppStatus = () => ({
    type: "ERROR_GET_WHATSAPP_STATUS",
});
export const getWhatsAppStatus = (handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestGetWhatsAppStatus());
        API.get(`/whatsapp/status`)
            .then((res) => {
                dispatch(successGetWhatsAppStatus(res.data));
                handleVisible && handleVisible(res.data.message);
            }).catch((error) => {
                dispatch(errorGetWhatsAppStatus());
                handleDangerVisible && handleDangerVisible();
            });
    };
};

// ─────────────────────────────────────────────────────────────────────────────
// SEND MESSAGE
// ─────────────────────────────────────────────────────────────────────────────
export const requestSendWhatsAppMessage = () => ({
    type: "REQUEST_SEND_WHATSAPP_MESSAGE",
});
export const successSendWhatsAppMessage = (data) => ({
    type: "SUCCESS_SEND_WHATSAPP_MESSAGE",
    payload: data,
});
export const errorSendWhatsAppMessage = () => ({
    type: "ERROR_SEND_WHATSAPP_MESSAGE",
});
export const sendWhatsAppMessage = (body, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestSendWhatsAppMessage());
        API.post(`/whatsapp/send-message`, body)
            .then((res) => {
                dispatch(successSendWhatsAppMessage(res.data));
                handleVisible && handleVisible(res.data.message);
            }).catch((error) => {
                dispatch(errorSendWhatsAppMessage());
                handleDangerVisible && handleDangerVisible();
            });
    };
};

// ─────────────────────────────────────────────────────────────────────────────
// SEND BULK MESSAGES
// ─────────────────────────────────────────────────────────────────────────────
export const requestSendBulkWhatsApp = () => ({
    type: "REQUEST_SEND_BULK_WHATSAPP",
});
export const successSendBulkWhatsApp = (data) => ({
    type: "SUCCESS_SEND_BULK_WHATSAPP",
    payload: data,
});
export const errorSendBulkWhatsApp = () => ({
    type: "ERROR_SEND_BULK_WHATSAPP",
});
export const sendBulkWhatsApp = (body, handleVisible, handleDangerVisible) => {
    return (dispatch) => {
        dispatch(requestSendBulkWhatsApp());
        API.post(`/whatsapp/send-bulk`, body)
            .then((res) => {
                dispatch(successSendBulkWhatsApp(res.data));
                handleVisible && handleVisible(res.data.message);
            }).catch((error) => {
                dispatch(errorSendBulkWhatsApp());
                handleDangerVisible && handleDangerVisible();
            });
    };
};

// ─────────────────────────────────────────────────────────────────────────────
// SOCKET ACTIONS — listen to server-emitted events and dispatch to Redux
// Call listenWhatsAppSocket(dispatch) once in your top-level component or store.
// ─────────────────────────────────────────────────────────────────────────────
export const setWhatsAppSocketStatus = (data) => ({
    type: "SET_WHATSAPP_SOCKET_STATUS",
    payload: data,
});
export const setWhatsAppQR = (data) => ({
    type: "SET_WHATSAPP_QR",
    payload: data,
});
export const listenWhatsAppSocket = () => {
    return (dispatch) => {
        // Server emits WHATSAPP_STATUS whenever connection state changes
        socket.on("WHATSAPP_STATUS", (data) => {
            dispatch(setWhatsAppSocketStatus(data));
        });

        // Server emits WHATSAPP_QR with a base64 data-URL of the QR image
        socket.on("WHATSAPP_QR", (data) => {
            dispatch(setWhatsAppQR(data));
        });
    };
};

export const stopWhatsAppSocketListeners = () => {
    return () => {
        socket.off("WHATSAPP_STATUS");
        socket.off("WHATSAPP_QR");
    };
};